import { ArrowRight, Phone, ShieldCheck, Flame, Wind } from "lucide-react";
import { COMPANY, WHATSAPP_URL } from "@/lib/constants";

const STATS = [
    {
        icon: ShieldCheck,
        label: "Lisboa · Porto · Algarve",
        value: "Zonas de atuação",
    },
    {
        icon: Flame,
        label: "Risco de incêndio",
        value: "Reduzido drasticamente",
    },
    {
        icon: Wind,
        label: "Resposta rápida",
        value: "Orçamento no mesmo dia",
    },
];

const HeroBackground = () => (
    <>
        <div
            className="absolute inset-0 opacity-[0.04] pointer-events-none"
            style={{
                backgroundImage:
                    "linear-gradient(to right, #000 1px, transparent 1px), linear-gradient(to bottom, #000 1px, transparent 1px)",
                backgroundSize: "80px 80px",
            }}
        />
        <div className="absolute top-0 right-0 w-1/2 h-2 bg-[#9B2C2C]" />
        <div className="absolute top-0 right-0 w-2 h-32 bg-[#9B2C2C]" />
        <div className="absolute top-0 left-0 w-2 h-2 bg-[#2E7D5B]" />
    </>
);

const HeroCtaRow = () => (
    <div data-testid="hero-cta-row" className="mt-12 flex flex-wrap gap-4 reveal">
        <a
            data-testid="hero-quote-btn"
            href="#contacto"
            className="group inline-flex items-center gap-3 bg-[#9B2C2C] text-white hover:bg-[#B83535] transition-all font-bold tracking-wider uppercase text-xs px-8 py-5"
        >
            Pedir Orçamento
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </a>
        <a
            data-testid="hero-phone-btn"
            href={`tel:${COMPANY.phoneIntl}`}
            className="group inline-flex items-center gap-3 bg-white border border-black/15 text-[#0A0A0A] hover:border-[#0A0A0A]/60 hover:bg-[#0A0A0A]/5 transition-all font-bold tracking-wider uppercase text-xs px-8 py-5"
        >
            <Phone className="w-4 h-4" />
            {COMPANY.phone}
        </a>
        <a
            data-testid="hero-whatsapp-btn"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-3 bg-white border border-[#25D366]/40 text-[#1FB755] hover:bg-[#25D366]/10 transition-all font-bold tracking-wider uppercase text-xs px-8 py-5"
        >
            WhatsApp
        </a>
    </div>
);

const HeroStats = () => (
    <div
        data-testid="hero-stats"
        className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-px bg-black/10 border border-black/10 reveal"
    >
        {STATS.map((s) => (
            <div key={s.label} className="bg-white p-6 flex items-start gap-4">
                <s.icon className="w-6 h-6 text-[#9B2C2C] mt-0.5" />
                <div>
                    <div className="label-tag mb-1">{s.label}</div>
                    <div className="font-display text-base font-bold uppercase tracking-tight text-[#0A0A0A]">
                        {s.value}
                    </div>
                </div>
            </div>
        ))}
    </div>
);

const Hero = () => (
    <section
        id="hero"
        data-testid="hero-section"
        className="relative min-h-screen w-full overflow-hidden bg-white"
    >
        <HeroBackground />

        <div className="relative z-10 px-6 md:px-12 lg:px-24 pt-32 pb-12 min-h-screen flex flex-col justify-center">
            <div className="max-w-5xl">
                <div
                    data-testid="hero-eyebrow"
                    className="flex items-center gap-3 mb-8 reveal"
                >
                    <span className="block w-12 h-px bg-[#2E7D5B]" />
                    <span className="label-tag" style={{ fontSize: "14px" }}>
                        Limpeza Técnica de Cozinhas Industriais · Portugal
                    </span>
                </div>

                <h1
                    data-testid="hero-title"
                    className="font-display text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-black uppercase leading-[0.95] tracking-tighter text-[#0A0A0A] reveal"
                >
                    Especialistas em <br />
                    <span className="text-[#9B2C2C]">Limpeza de Hottes</span> <br />
                    & Sistemas de Extração.
                </h1>

                <p
                    data-testid="hero-subtitle"
                    className="mt-8 max-w-2xl text-base sm:text-lg text-[#0A0A0A]/65 leading-relaxed font-light reveal"
                >
                    {COMPANY.subtitle} Desengorduramento profissional de hottes,
                    condutas, motores e sistemas de ventilação para restaurantes,
                    hotéis e cozinhas industriais em todo o país.
                </p>

                <HeroCtaRow />
            </div>

            <HeroStats />
        </div>
    </section>
);

export default Hero;
